<template>
  <div style="Loginall">
    <div>
      <div class="mytop">
        <div class="images">
          <router-link to="/text"> <img src="/static/saw_new_logo.jpg"></router-link>
        </div>
        <div class="fontCnTxt"><a class="cnTxt" href="/intelligentlanguage/zh">中文</a> |
          <a class="enTxt" href="/intelligentlanguage/en">English</a>
        </div>
      </div>
      <div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="loginMain">
      <div class="formLogin">

        <h1 class="ESCloginTit">
         SCOTLAND ACADEMY
        </h1>
        <div class="formtext">
          <el-form :model="ruleForm" :rules="loginRules" ref="loginRef" label-width="80px" v-loading="loading">
            <el-form-item prop="username">
              <el-input type="text" placeholder="用户名/学生号/手机号" @keyup.enter.native="submitForm()"
                v-model="ruleForm.username"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" placeholder="密码" @keyup.enter.native="submitForm()"
                v-model="ruleForm.password" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="ESCloginBtn" @click="submitForm()">登录</el-button>
              <el-button @click="getPssword">忘记密码</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog title="找回密码" center :visible.sync="getPassword" width="50%">
      <el-form :model="resetForm" :rules="resetRules" ref="resetref" label-width="100px" class="demo-ruleForm">
        <el-form-item label="用户名" v-show="showUsername" >
          <el-input v-model="resetForm.username"></el-input>
        </el-form-item>
        <el-form-item label="手机号" v-show="showUsername" prop="mobiles">
          <el-input v-model="resetForm.mobiles" type="number" oninput="if(value.length>11)value=value.slice(0,11)">
            <el-button slot="append" @click="SendMessage()" v-if="!sendPower">点击发送验证码</el-button>
            <el-button slot="append" v-if="sendPower">请于{{ time }}秒后重试</el-button>
          </el-input> 
        </el-form-item>
        <el-form-item label="验证码" v-show="showUsername" prop="authCode">
          <el-input type="number" oninput="if(value.length>6)value=value.slice(0,6)" v-model="resetForm.authCode">
          </el-input>
        </el-form-item>
        <el-form-item v-if="showPassword" label="新密码" prop="newPassword">
          <el-input v-model="resetForm.newPassword"></el-input>
        </el-form-item>
      </el-form>
      <div class="updatePassword">
        <el-button type="primary" v-show="showUsername" @click="submitUpdate">确定</el-button>
      <el-button type="primary" v-show="showPassword" @click="submitUpdatePassword">修改</el-button>
      </div>
    </el-dialog>

    <el-dialog
  :visible.sync="vilLogin"
  :close-on-click-modal=false
  width="380px"
 >
 <div class="line-two">
          <slide-verify
            :l="42"
            :r="10"
            :w="330"
            :h="165"
            ref="slideblock"
            slider-text="请拖动滑块完成验证再确认领取"
            @success="onSuccess"
            @fail="onFail"
            @refresh="onRefresh"
            :imgs="verfiedImgs"
            :accuracy='5'
          ></slide-verify>
        </div>
</el-dialog>

  </div>
</template>

<script>

import { checkMobiles, getUsername ,checkPassword} from '@/components/work/until/vaildate.js'

export default {
  data() {
    var usernameAndMobiles = (rule, value, callback) => {
      this.$refs.resetref.validateField('username')
      this.axios.post("/user/vailMobiles?username=" + this.resetForm.username + "&mobiles=" + this.resetForm.mobiles)
        .then(resp => {
          if (resp.data.status == 1) {
            callback();
          } else {
            callback(new Error("用户名和绑定号码不匹配"))
          }
        })
        .catch((err) => {
          // alert("出错了")
          console.log(err)
        })
    }
    return {
      loading: false,
      getPassword: false,
      sendPower: false,
      showPassword: false,
      showUsername: true,
      vilLogin:false,
      time: '',
      times:2,
      ruleForm: {
        username: '',
        password: ''
      },
      resetForm: {
        username: '',
        mobiles: '',
        number: '',
        newPassword: '',
      },


      verfiedImgs: [
        
          "./static/verifiedImgs/hd1.jpg",
          "./static/verifiedImgs/park5.jpg",
          "./static/verifiedImgs/yh2.jpg",
          "./static/verifiedImgs/office3.jpg",
          "./static/verifiedImgs/office4.jpg",

        ], 
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: checkPassword, trigger: 'blur' },
        ],
      },
      resetRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { validator: getUsername, trigger: 'blur' },
        ], mobiles: [{ required: true, message: '请输入手机号', trigger: 'blur' },
        // { validator: checkMobiles, trigger: 'blur' },
        { validator: usernameAndMobiles, trigger: 'blur' }],
        authCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '长度为6位数字', trigger: 'blur' }
        ],newPassword:[
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: checkPassword, trigger: 'blur' },
        ]
      }
    }
  }, 
  methods: {
    submitForm() {
      this.$refs.loginRef.validate(
        (vaild) => {
          if (!vaild)
            return
            this.getLogin()
          // var username = window.btoa(this.ruleForm.username)
          var pwd = window.btoa(this.ruleForm.password)
          if(this.times>0&sessionStorage.getItem("loginVil")!=null){
        
          }else{
            return false
          }
          this.loading = true
          this.axios.post("/user/login", "username=" + this.ruleForm.username + "&password=" + pwd)
            .then(resp => {
              if (resp.data.status == 1) {
                this.loading = false
                console.log(resp.data.result)
                let token = resp.data.result.token
                localStorage.removeItem
                localStorage.setItem('user', JSON.stringify(resp.data.result));                localStorage.token = token;
                this.$message({
                    message: '登录成功',
                    type: 'success'
                  });
                if (resp.data.result.type == 2) { //管理员
                  this.$router.push({  //核心语句
                    name: 'bam',   //跳转的路径
                  })
                } else if (resp.data.result.type == 1) {//学生登录
                  this.$router.push({  //核心语句
                    name: 'StudentBam',   //跳转的路径
                  })
                } else if (resp.data.result.type == 0) {//老师登录
                  this.$router.push({  
                    name: 'TeacherBam',   
                  })
                } else if (resp.data.result.type == 3) {//家长登录
                  this.$router.push({  
                    name: 'ParentBam',   
                  })
                } else if (resp.data.result.type == 4) {//领导登录
                  this.$router.push({  
                    name: 'leaderBam',   
                  })
                } else if (resp.data.result.type == 5) {//辅导员登录登录
                  this.$router.push({  
                    name: 'InstructorBam',  
                  })
                }else if (resp.data.result.type == 6) {//行政人员登录
                  this.$router.push({  
                    name: 'administrativeBam',  
                  })
                }else if (resp.data.result.type == 7) {//专业老师人员登录
                  this.$router.push({  
                    name: 'professionalTeacherBam',  
                  })
                }
              } else {
                this.times=this.times-1
                this.loading = false
                this.$message.error(resp.data.message)
              }
            })
            .catch((err) => {
              this.loading = false
              alert("出错")

            })
        }
      )
    },
    getPssword() {
      this.getPassword = true
    },
    onSuccess() {
      sessionStorage.setItem("loginVil","1")
      this.vilLogin=false
      this.times=3
      this.$refs.slideblock.reset()
      this.submitForm()
        console.log("成功回调");
      },
      onFail() {
        console.log("失败回调");
      },
      onRefresh() {
        console.log("刷新回调");
      },
      getLogin(){
        let login=sessionStorage.getItem("loginVil")
        if(login==null){
          this.vilLogin=true
        }else{
          if(this.times<=0){
            sessionStorage.clear("loginVil")
            this.vilLogin=true
          }else{
            this.vilLogin=false
          }
        }
      },
    SendMessage() {
      this.$refs.resetref.validateField('mobiles', valid => {
        if (valid) {
          return
        }
        this.setTime(60)
        this.setSendCodeLoadingStat(true)
        this.axios.post("/user/SendMessage2?mobiles=" + this.resetForm.mobiles + "&username=" + this.resetForm.username)
          .then(resp => {
            if (resp.data.status == 1) {
              this.$message.success("发送成功")
            } else {
              this.$message.error("发送失败")
              this.$message.error(resp.data.message)
              console.log(resp.data.result)
            }
          })
          .catch((err) => {
            // alert("出错了")
            console.log(err)
          })
      })
    }, setTime(val) {
      this.time = val.toString()
      if (val == 0) {
        //当发送定时器结果为0
        this.setSendCodeLoadingStat(false)
        return
      } else {
        val--
      }
      setTimeout(res => {
        //设置一个定时器，每秒刷新一次
        this.setTime(val)
      }, 1000)
    },
    setSendCodeLoadingStat(state) {
      //发送验证码时的加载动画显示
      this.sendPower = state //更改按钮是否可以点击 true为不可点击
    }, submitUpdate() {
      this.$refs.resetref.validate((valid) => {
        if (!valid)
          return
        const formData = new FormData()
        let config = { headers: { "Content-Type": "application/json" } };          // const formData = new FormData()
        formData.append("username", this.resetForm.username)
        formData.append('mobiles', this.resetForm.mobiles)
        formData.append('authCode', this.resetForm.authCode)
        this.axios.post("/user/getvailAuthCode", formData, config)
          .then((resp) => {
            if (resp.data.status == 1) {
              this.$message.success("验证成功请输入新密码");
              this.showPassword = true
              this.showUsername = false
            } else {
              this.$message.error(resp.data.message)
              alert("拿取数据失败");
            }
          })
          .catch((err) => {
            this.$message.error("出错");
          });

      })

    }, submitUpdatePassword() {
      this.$refs.resetref.validate((valid) => {
        if (!valid)
          return
        const formData = new FormData()
        let config = { headers: { "Content-Type": "application/json" } };          // const formData = new FormData()
        formData.append("username", this.resetForm.username)
        formData.append('mobiles', this.resetForm.mobiles)
        formData.append('newPassword', window.btoa(this.resetForm.newPassword))
        formData.append('authCode', this.resetForm.authCode)
        this.axios.post("/user/updatePassword", formData, config)
          .then((resp) => {
            if (resp.data.status == 1) {
              this.$message.success("修改成功");
              this.$refs.resetref.resetFields()
              this.getPassword = false
              this.showPassword = false
              this.showUsername = true
            } else {
              alert("拿取数据失败33");
            }
          })
          .catch((err) => {
            this.$message.error("出错");
          });

      })
    },

  }
}
</script>

<style scoped>
.mytop {
  height: 60px;
  width: 100%;
  /* background-color: #0065bd; */
  padding: 10px 10px;
  /* justify-content:space-between; */
}

img {
  overflow: hidden;
  width: 190px;
  height: 100%;
   margin-left: 20px;
}

.images {
  height: 100%;
  margin: auto;
  padding: auto;
  float: left;

}

.fontCnTxt {
  height: 100%;
  float: right;
  font-size: 12px;
  padding-top: 10px;
  padding-right: 15px;

}

a {
  color: #000;
}

.loginMain {
  height: 630px;
  width: 100%;
  min-width: 500px;
  background-size: repeat;
  background-image: url('http://www.ebookware.cn/video/thu_saw.jpg');
  /* background-image: url(	http://saw.wxu.edu.cn/r/cms/sglxy/sglxy/images/sydt/2.jpg); */
}
/* .line-two {
    padding: 1rem;
    background: white;

  } */
image {
  height: 1000px;
  width: 100%;
  overflow: hidden;
  padding-left: 25px;
}

.Loginall {
  margin: 0;
}

.formLogin {
  width: 418px;
  height: 342.2px;
  margin: 60px;
  border: 1px solid #fafbfd;
  background-color: #f1f2f4;
  float: right;
  opacity: 0.9;
}

.ESCloginTit {
  font-size: 22px;
  font-weight: bold;
  color: #666;
  padding: 22px 0 0 0;
  text-align: center;
  font-family: 'Open Sans', sans-serif;
  margin-top: 0;
  margin-bottom: 0;
}

.formtext {
  margin: auto;
  margin-top: 30px;
}

.el-input {

  width: 80%;
}

.ESCloginBtn {
  width: 80%;
  height: 60px;
  color: #fff;
  background-color: #0367d9;
  border-radius: 4px;
  border: none;
  font-size: 22px;
  font-family: 'Open Sans', sans-serif;
  letter-spacing: 5px;
  cursor: pointer;
  outline: none;
  margin: auto;
  text-align: center;
  margin-bottom: 16px;
  overflow: hidden;
}

.updatePassword{
 text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/work/login.vue